import { useBrand } from './brand-context';
import { BRAND_TOKENS } from './registry';
import type { BrandTokens } from './registry';

const useBrandTokens = (): BrandTokens => BRAND_TOKENS[useBrand().brand];

export { useBrandTokens };
